export const FAVORITE_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="none">
    <path fill="#FF1F34" d="M0 3.006C0 6.973 5.5 10 5.5 10S11 6.973 11 3.006C11 1.346 9.618 0 7.912 0 6.936 0 6.066.441 5.5 1.13A3.114 3.114 0 003.088 0C1.382 0 0 1.346 0 3.006z"/>
  </svg>
`;
